"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const PropTypes = __importStar(require("prop-types"));
const clsx_1 = require("clsx");
const FontIcon_1 = __importDefault(require("../../icon/FontIcon"));
const tooltip_1 = require("../../tooltip");
const date_fns_1 = require("date-fns");
const eventUtils_1 = require("../../common/eventUtils");
const Header = ({ date, dir, labels, months, onChange, onVisible, onClose, parentRef, showTooltip, currentID, }) => {
    const changeYear = (amount) => {
        onChange((0, date_fns_1.addYears)(date, amount));
    };
    const changeMonth = (amount) => {
        onChange((0, date_fns_1.addMonths)(date, amount));
    };
    const handleOpen = (event, id) => {
        if (event.nativeEvent.type === 'focus' &&
            !event.target.classList.contains('focus-visible')) {
            // If the event target has not focus-visible then it is a focus by programmatically
            return;
        }
        onVisible(id);
    };
    const handleClose = () => {
        onClose();
    };
    /**
     * Change the behaviour of 'Tab' and 'Shift + Tab' event of an html element
     * Used to allow loop navigation "'Today Button' --> Header (<<) --> Header (<)"
     */
    const ajustLoopNavigation = (event) => {
        if (!parentRef) {
            return;
        }
        if (event.key === eventUtils_1.Keys.TAB) {
            (0, eventUtils_1.cancelEvent)(event);
            if (event.shiftKey) {
                const elClassPrevious = parentRef.querySelector('.tk-daypicker-today');
                if (elClassPrevious) {
                    elClassPrevious.focus();
                }
            }
            else {
                const elClassNext = parentRef.querySelector('.tk-daypicker-header--prevMonth');
                if (elClassNext) {
                    elClassNext.focus();
                }
            }
        }
    };
    const tooltipButton = (buttonID, label, className, iconName, onChangeNumber, isYearButton) => {
        return ((0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { id: buttonID, description: label, visible: showTooltip && currentID === buttonID, type: "tooltip", placement: buttonID === 'PREVIOUS_YEAR' || buttonID === 'PREVIOUS_MONTH'
                ? 'top-start'
                : 'top', children: (0, jsx_runtime_1.jsx)("button", { "aria-label": label, className: (0, clsx_1.clsx)(className, 'tk-daypicker-header--button'), onClick: () => isYearButton
                    ? changeYear(onChangeNumber)
                    : changeMonth(onChangeNumber), onMouseEnter: (e) => handleOpen(e, buttonID), onFocus: (e) => handleOpen(e, buttonID), onMouseLeave: () => handleClose(), onBlur: () => handleClose(), onKeyDown: buttonID === 'PREVIOUS_YEAR' ? ajustLoopNavigation : undefined, children: (0, jsx_runtime_1.jsx)(FontIcon_1.default, { iconName: iconName }) }) }));
    };
    const textHeader = `${months[date.getMonth()]} ${date.getFullYear()}`;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "tk-daypicker-header", role: "heading", style: { direction: dir }, children: [(0, jsx_runtime_1.jsxs)("div", { children: [tooltipButton('PREVIOUS_YEAR', labels.previousYear, 'tk-daypicker-header--prevYear', dir === 'rtl' ? 'chevron-right' : 'chevron-left', -1, true), tooltipButton('PREVIOUS_MONTH', labels.previousMonth, 'tk-daypicker-header--prevMonth', dir === 'rtl' ? 'right' : 'left', -1, false)] }), (0, jsx_runtime_1.jsx)("div", { className: "tk-daypicker-header--text", children: textHeader }), (0, jsx_runtime_1.jsxs)("div", { children: [tooltipButton('NEXT_MONTH', labels.nextMonth, 'tk-daypicker-header--nextMonth', dir === 'rtl' ? 'left' : 'right', 1, false), tooltipButton('NEXT_YEAR', labels.nextYear, 'tk-daypicker-header--nextYear', dir === 'rtl' ? 'chevron-left' : 'chevron-right', 1, true)] })] }));
};
Header.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    dir: PropTypes.oneOf(['rtl', 'ltr']).isRequired,
    labels: PropTypes.exact({
        nextMonth: PropTypes.string.isRequired,
        previousMonth: PropTypes.string.isRequired,
        previousYear: PropTypes.string.isRequired,
        nextYear: PropTypes.string.isRequired,
    }).isRequired,
    months: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func,
    parentRef: PropTypes.any,
};
exports.default = Header;
